@if (lorenzFormControl && lorenzFormGroup) {

	<div [formGroup]="lorenzFormGroup"
		 class="outer-wrapper">

		<div class="control-wrapper"
			 [ngClass]="{
			 	'highlighted': lorenzFormControl.isHighlighted(),
			 	'missing-required': lorenzFormControl.isMissingRequiredValue()
			 }">

			<input type="checkbox"
				   [formControl]="lorenzFormControl"

				   [id]="'input-' + this.hostId"

				   class="control"
				   [ngClass]="{
						'readonly': lorenzFormControl.isBlocked(),
						'missing-required': lorenzFormControl.isMissingRequiredValue()
				   }"

				   (click)="readonlyHandler($event)"
			>

			@if (isLayoutFloatingLabels && lorenzFormControl.hasLabel()) {

				<label class="label"
					 [for]="'input-' + this.hostId"
					 [ngClass]="{
					 	'highlighted': lorenzFormControl.isHighlighted(),
					 	'missing-required': lorenzFormControl.isMissingRequiredValue()
					 }">
					{{ lorenzFormControl.getLabel() | translate }}
				</label>

			}

			@if (lorenzFormControl.getLabelAfter() || lorenzFormControl.hasText()) {
				<label class="label-wrapper"
					 [for]="'input-' + this.hostId"
					 [ngClass]="{
					 	'highlighted': lorenzFormControl.isHighlighted(),
					 	'missing-required': lorenzFormControl.isMissingRequiredValue()
					 }">
					@if (lorenzFormControl.getLabelAfter()) {
						<div class="label-after">
							<span [innerHTML]="lorenzFormControl.getLabelAfter() | translate"></span>
						</div>
					}

					@if (lorenzFormControl.hasText()) {
						<div class="text"
							 [innerHTML]="lorenzFormControl.getText()">
						</div>
					}
				</label>
			}

			@if (!isGroupCheck) {
				<lib-form-validity-dot [control]="lorenzFormControl"></lib-form-validity-dot>
			}

		</div>

		@if (showErrorMessages) {
			<div class="error">{{ lorenzFormControl.getErrors() | translate }}</div>
		}

	</div>

}
